(() => {
  // app/scripts/component/cartRemove.js
  window.customElements.define("cart-remove", class extends HTMLButtonElement {
    constructor() {
      super();
      this.addEventListener("click", this.onClick.bind(this));
    }
    async onClick() {
      // Insert .js before the query string if it exists
      let url = this.dataset.url;
      const queryIndex = url.indexOf('?');
      if (queryIndex !== -1) {
        url = url.substring(0, queryIndex) + '.js' + url.substring(queryIndex);
      } else {
        url = url + '.js';
      }

      try {
        const response = await fetch(url, {
          credentials: "same-origin",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          }
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const cartContent = await response.json();
        document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
          bubbles: true,
          detail: {
            cart: cartContent
          }
        }));
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: {
            cart: cartContent
          }
        }));
      } catch (error) {
        console.error('Error removing item from cart:', error);
        // Fallback: reload the page if AJAX fails
        window.location.reload();
      }
    }
  }, { extends: "button" });

  // app/scripts/function/cookie.js
  var cookie = {
    get: function(key) {
      var keyValue = document.cookie.match("(^|;) ?" + key + "=([^;]*)(;|$)");
      return keyValue ? JSON.parse(keyValue[2]) : null;
    },
    set: function(key, value, expiry) {
      var expires = /* @__PURE__ */ new Date();
      expires.setTime(expires.getTime() + expiry * 24 * 60 * 60 * 1e3);
      document.cookie = key + "=" + JSON.stringify(value) + ";expires=" + expires.toUTCString() + ";path=/";
    },
    delete: function(key) {
      var keyValue = this.get(key);
      this.set(key, keyValue, "-1");
    }
  };

  // app/scripts/function/ymmUtils.js
  const YMM_APP_BASE = '/apps/boost-ymm';
  const DROPDOWNS_API = `${YMM_APP_BASE}/api/dropdowns`;
  const SEARCH_API = `${YMM_APP_BASE}/api/search`;
  const FITMENT_API = `${YMM_APP_BASE}/api/fitment`;

  let ymmDropdownData = null;

  async function loadDropdownData() {
    if (ymmDropdownData) return ymmDropdownData;
    const response = await fetch(DROPDOWNS_API);
    ymmDropdownData = await response.json();
    return ymmDropdownData;
  }

  /**
   * Determine whether results are empty.
   * True when only Universal fitment items are in the response.
   * @param {Array} products - Products from YMM API response.
   * @returns {Boolean}
   */
  function isEmpty(products) {
    const container = document.querySelector('ymm-filter-component');
    const { enableAllUniversal } = container?.dataset;
    const totalLength = products.length;

    if (totalLength > 0 && enableAllUniversal) {
      return false;
    }

    const allUniversal = !products.some(product => {
      return !product?._source?.metafields?.ymma_fitment?.value.includes('Universal');
    });

    return allUniversal;
  }

  async function getFitmentTableData(productID) {
    if (this.cachedFitmentTableData) {
      return Promise.resolve(this.cachedFitmentTableData);
    }
    const response = await fetch(`${FITMENT_API}/${productID}`);
    const data = await response.json();
    const fitmentTableData = {
      _source: {
        ymms: data.fitments.map(f => ({
          year: f.year,
          make: f.make,
          model: f.model,
          note: f.note || ''
        }))
      }
    };
    this.cachedFitmentTableData = fitmentTableData;
    return fitmentTableData;
  }
  function saveYMMSelectorValues(array) {
    array.forEach((select) => {
      const name = select.getAttribute("name");
      const key = `ymm-${name}`;
      const value = String(select.value);
      localStorage.setItem(key, value);
    });
  }
  function resetYMMValueInLocalStorage(array) {
    array.forEach((select) => {
      const name = select.getAttribute("name");
      const key = `ymm-${name}`;
      const value = "";
      localStorage.setItem(key, value);
    });
  }
  function getYMMValue() {
    const must = [];
    const ymmSelector = document.querySelector("ymm-selector");
    ymmSelector.querySelectorAll(".jsYMMSelect").forEach((item) => {
      item.value != "" && must.push({
        "match": {
          [`ymms.${item.name}`]: item.value
        }
      });
    });
    return must.length ? {
      "nested": {
        "path": "ymms",
        "query": {
          "bool": {
            must
          }
        }
      }
    } : null;
  }
  function hasYMMData() {
    const year = localStorage.getItem("ymm-year") || "";
    const make = localStorage.getItem("ymm-make") || "";
    const model = localStorage.getItem("ymm-model") || "";
    return year.length > 0 || make.length > 0 || model.length > 0;
  }
  function getSortQuery() {
    const sortElment = document.querySelector('input[name="ymm_sort"]:checked');
    if (!sortElment) {
      return void 0;
    }
    let order;
    if (sortElment.value.includes("ascending"))
      order = "asc";
    else
      order = "desc";
    return [
      {
        "variants.price": {
          "mode": "avg",
          order,
          "nested": {
            "path": "variants"
          }
        }
      }
    ];
  }
  function ymmFilterParams() {
    const params = [];
    let hasPrice = false;
    document.querySelectorAll(".jsYMMParams").forEach((item) => {
      if (item.type == "checkbox" && item.checked) {
        params.push({
          "match": {
            [item.dataset.ymm]: item.value
          }
        });
      } else if (item.classList.contains("jsYMMPrice") && !hasPrice) {
        hasPrice = true;
        const object = {};
        document.querySelectorAll(".jsYMMPrice").forEach((item2) => {
          object[item2.dataset.ymm] = +item2.value;
        });
        params.push({
          "nested": {
            "path": "variants",
            "query": {
              "bool": {
                "must": [
                  {
                    "range": {
                      "variants.price": object
                    }
                  }
                ]
              }
            }
          }
        });
      }
    });
    return params;
  }
  function ymmFilter() {
    let must = [];
    const ymmValue = getYMMValue.call(this);
    const { size, page } = this.dataset;
    const from = (page || 0) * (size || 25);
    const params = ymmFilterParams.call(this);
    const sortParms = getSortQuery();
    let sort = void 0;
    ymmValue && must.push(ymmValue);
    if (params.length)
      must = must.concat(params);
    if (sortParms)
      sort = { sort: sortParms };
    return {
      "_source": {
        "exclude": [
          "ymms.*"
        ]
      },
      from,
      size,
      "query": {
        "bool": {
          must
        }
      },
      ...sort
    };
  }
  function setYMMSelectorValue(fieldName, values, useCache = true) {
    const selectedValue = useCache ? localStorage.getItem(`ymm-${fieldName}`) : null;
    const initOption = `<option value="">${fieldName.toUpperCase()}</option>`;
    const options = values.map((value) => {
      return `<option value="${value}"${value === selectedValue ? " selected" : ""}>${value}</option>`;
    });
    const html = [initOption, ...options].join("");
    for (const select of document.querySelectorAll(`.ymm-${fieldName}-select`)) {
      select.innerHTML = html;
      select.removeAttribute("disabled");
    }
  }
  function loadYMMFromCache(array) {
    let str = [];
    for (const field of array) {
      const value = localStorage.getItem(`ymm-${field}`);
      if (value == null || value.trim() === "")
        continue;
      str.push(value);
      document.querySelectorAll(`.ymm-${field}-select`).forEach((select) => {
        select.value = value;
        if (!select.value) {
          const option = document.createElement("option");
          option.value = value;
          option.innerHTML = value;
          select.appendChild(option);
          select.value = value;
        }
      });
    }
    return str.join(" ");
  }
  function getYMMURLParams(array) {
    const params = array.map((key) => {
      const value = localStorage.getItem(`ymm-${key}`);
      if (value == null || value.trim() === "")
        return "";
      return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
    });
    let paramsURL = params.filter((u) => u.length);
    return paramsURL.length ? `?${paramsURL.join("&")}` : "";
  }
  function getYMMParamsFromURL(array) {
    let queryString = new URLSearchParams(location.search);
    const nameList = ["year", "make", "model", "generation"];
    const hasGenerationOnly = queryString.get("generation") && !queryString.get("year");
    for (const name of nameList) {
      const key = `ymm-${name}`;
      const value = queryString.get(name);
      if (value) {
        localStorage.setItem(key, value);
      } else if (name === "generation") {
        localStorage.removeItem(key);
      } else if (hasGenerationOnly && ["year", "make", "model"].includes(name)) {
        localStorage.removeItem(key);
      }
    }
  }

  // app/scripts/component/ymmSelector.js
  document.body.addEventListener("click", function(e) {
    if (window.matchMedia("(max-width: 991px)").matches) {
      const header_ymm_selector = document.querySelector('ymm-selector[data-section="header"]');
      if (header_ymm_selector.classList.contains("tooltip-active") && !e.target.closest('ymm-selector[data-section="header"]')) {
        header_ymm_selector.classList.remove("tooltip-active");
      }
    }
    if (!e.target.closest("ymm-selector") && document.querySelector("ymm-selector details[open]")) {
      document.querySelector("ymm-selector details[open]").open = false;
    }
    if (e.target.closest(".jsYMMBtn") && document.getElementById("ymmSelector")) {
      document.getElementById("ymmSelector").focus();
      document.getElementById("ymmSelector").open = true;
      document.getElementById("ymmSelector").closest(".tooltip-active")?.classList.remove("tooltip-active");
    }
  });
  document.documentElement.addEventListener("ymm:filter:loaded", () => {
    document.getElementById("ymmSelector").setAttribute("data-state", "select");
  });
  customElements.define("ymm-selector", class extends HTMLElement {
    constructor() {
      super();
      this.setDefault();
      if (sessionStorage.getItem("ymm-tooltip-dismissed")) {
        this.classList.add("tooltip-dismissed");
      }
      this.showToolTip();
      this.hasAttribute("auto-fetch") && this.initialize(true);
      this.addEventListener("change", this.onChange.bind(this));
      this.addEventListener("mouseleave", () => {
        this.classList.remove("tooltip-active");
      }, { once: true });
      this.addEventListener("click", (e) => {
        if (e.target.closest(".jsYMMSubmit"))
          this.submit(e);
        if (e.target.closest(".jsYMMSave"))
          this.save(e);
        if (e.target.closest(".jsYMMReset"))
          this.reset(e);
        if (e.target.closest(".close-tooltip")) {
          this.classList.remove("tooltip-active");
          this.classList.add("tooltip-dismissed");
          sessionStorage.setItem("ymm-tooltip-dismissed", "true");
        }
      });
      this.closest(".header") && document.addEventListener("click", (e) => {
        if (e.target.closest(".jsYMMViewAll"))
          this.submit(e);
      });
    }
    setDefault() {
      this.page = 0;
      this.size = +this.dataset.size || 25;
      this.ymmSelectors = [...this.querySelectorAll(".jsYMMSelect")];
      this.paramsList = this.ymmSelectors.map((item) => item.name);
      getYMMParamsFromURL(this.paramsList);
      document.addEventListener("ymm", (e) => {
        for (const select of document.querySelectorAll(`.ymm-${e.name}-select`)) {
          select.value = e.value;
        }
      });
      !loadYMMFromCache(this.paramsList) && this.closest("#ymmPopup") && window.addEventListener("DOMContentLoaded", () => {
        this.closest("#ymmPopup").open = true;
      });
    }
    async initialize() {
      const data = await loadDropdownData();
      setYMMSelectorValue('year', data.years);

      const cachedYear = localStorage.getItem('ymm-year');
      if (cachedYear) {
        const makes = data.makes[cachedYear] || [];
        if (makes.length) {
          setYMMSelectorValue('make', makes);
        }

        const cachedMake = localStorage.getItem('ymm-make');
        if (cachedMake) {
          const models = data.models[`${cachedYear}|${cachedMake}`] || [];
          if (models.length) {
            setYMMSelectorValue('model', models);
          }
        }
      }

      this.setVehicleValue();
      this.updateURL();
      document.dispatchEvent(new CustomEvent("ymmData:Loaded"));
    }
    async onChange({ target: currentTarget }) {
      const currentSelector = currentTarget.closest("select");
      const index = this.ymmSelectors.indexOf(currentSelector) + 1;
      this.resetAllNextSelectors(index);
      const nextSelector = this.ymmSelectors[index];
      this.toggleSubmitButtonAttribute = this.isSelectorValid();
      if (!nextSelector || !currentSelector.value.length) {
        return;
      }
      const data = await loadDropdownData();
      const year = this.ymmSelectors[0].value;
      const make = this.ymmSelectors[1]?.value;
      if (nextSelector.name === 'make') {
        const makes = data.makes[year] || [];
        setYMMSelectorValue('make', makes, false);
      } else if (nextSelector.name === 'model') {
        const key = `${year}|${make}`;
        const models = data.models[key] || [];
        setYMMSelectorValue('model', models, false);
      }
    }
    resetAllNextSelectors(i) {
      document.querySelectorAll("ymm-selector").forEach((selector) => {
        let ymmSelectors = selector.ymmSelectors;
        for (let index = i; index < ymmSelectors.length; index++) {
          let select = ymmSelectors[index];
          select.innerHTML = `<option value>${select.dataset.placeholder || select.name.toUpperCase()}</option>`;
          select.setAttribute("disabled", "disabled");
        }
      });
    }
    set toggleSubmitButtonAttribute(value) {
      document.querySelectorAll(".vehicle__submit:not(.vehicle__reset) button").forEach((button) => {
        button.toggleAttribute("disabled", value);
      });
    }
    onSelected() {
      document.dispatchEvent(new CustomEvent("ymmData:Changed"));
      const isHeaderSelector = this.closest("#shopify-section-header");
      window.dispatchEvent(new CustomEvent("ymm:filter", {
        detail: { noScroll: !!isHeaderSelector }
      }));
    }
    submit(event) {
      this.save(event);
      if (this.closest("ymm-filter-component, ymm-filter-section")) {
        return;
      }
      location.href = this.dataset.url + getYMMURLParams(this.paramsList);
    }
    save(event) {
      event.preventDefault();
      saveYMMSelectorValues(this.ymmSelectors);
      this.updateURL();
      this.setVehicleValue();
      if (event.target.closest("#ymmSelector")) {
        event.target.closest("#ymmSelector").removeAttribute("open");
        this.showToolTip("save");
      }
      this.onSelected();
    }
    reset(event) {
      event.preventDefault();
      resetYMMValueInLocalStorage(this.ymmSelectors);
      this.resetAllNextSelectors(0);
      this.initialize();
      this.updateURL();
      this.onSelected();
      let homeFilterSection = document.querySelector("ymm-selector[auto-filter]");
      if (!homeFilterSection)
        return;
      homeFilterSection.callFilter();
    }
    set open(bool) {
      const details = this.querySelector("details");
      if (!details)
        return;
      details.open = bool;
    }
    showToolTip(type = "tutorial") {
      if (!this.querySelector("details"))
        return;
      if (sessionStorage.getItem("ymm-tooltip-dismissed"))
        return;
      const cookie_key = type == "tutorial" ? "disabled__tooltip__tutorial" : "disabled__tooltip__save";
      if (!cookie.get(cookie_key) || type == "tutorial" && hasYMMData() && !cookie.get("disabled__tooltip__returning")) {
        this.classList.add("tooltip-active");
        if (!cookie.get(cookie_key)) {
          cookie.set(cookie_key, true, 3);
        } else {
          cookie.set("disabled__tooltip__returning", true, 3);
        }
        const isCloseManually = document.querySelector("ymm-selector").dataset.ismanually === "true";
        if (!isCloseManually) {
          if (this.toolTipShow != null)
            clearTimeout(this.toolTipShow);
          this.toolTipShow = setTimeout(() => {
            this.classList.remove("tooltip-active");
            this.toolTipShow = null;
          }, 3e3);
        }
      }
    }
    setVehicleValue() {
      let str = loadYMMFromCache(this.paramsList);
      async function setFitNote() {
        if (!window.theme.product)
          return;
        const result = await getFitmentTableData(window.theme.product.id);
        const fitmentTable = result?._source?.ymms;
        if (str.length) {
          let fitSelected = str;
          fitSelected = fitSelected.split(" ").join("-");
          fitSelected = fitSelected.toLowerCase();
          fitmentTable?.forEach((fitItem) => {
            let vehicleFitment = `${fitItem.year} ${fitItem.make} ${fitItem.model}`;
            vehicleFitment = vehicleFitment.split(" ").join("-");
            vehicleFitment = vehicleFitment.toLowerCase();
            if (fitSelected == vehicleFitment) {
              if (fitItem.note) {
                document.querySelectorAll(".jsFitNote").forEach((item) => {
                  item.innerHTML = `Note: ${fitItem.note}`;
                  item.style.display = "block";
                });
              } else {
                document.querySelectorAll(".jsFitNote").forEach((item) => {
                  item.innerHTML = "";
                  item.style.display = "none";
                });
              }
            }
          });
        } else {
          document.querySelectorAll(".jsFitNote").forEach((item) => {
            item.innerHTML = "";
            item.style.display = "none";
          });
        }
      }
      setFitNote();
      if (str.length) {
        this.toggleSubmitButtonAttribute = this.isSelectorValid();
        document.querySelectorAll(".jsFitValue").forEach((item) => {
          if (item.closest("ymm-fitment")) {
            item.closest("ymm-fitment").style.opacity = 0;
          }
          item.innerHTML = str;
        });
        document.querySelectorAll("ymm-selector").forEach((selector) => selector.classList.add("submitted"));
        this.querySelector("#ymmSelector")?.setAttribute("data-state", "select");
      } else {
        document.querySelectorAll(".jsFitValue").forEach((item) => {
          if (item.closest("ymm-fitment")) {
            item.closest("ymm-fitment").style.opacity = 0;
          }
          item.innerHTML = "";
        });
        this.querySelector("#ymmSelector")?.setAttribute("data-state", "unselect");
        document.querySelectorAll("ymm-selector").forEach((selector) => selector.classList.remove("submitted"));
      }
    }
    updateURL() {
      let searchArr = [];
      let newUrl = window.location.origin + window.location.pathname;
      let ymmParams = getYMMURLParams(this.paramsList);
      let queryString = new URLSearchParams(location.search);
      for (let pair of queryString.entries()) {
        const [name, value] = pair;
        !this.paramsList.includes(name) && searchArr.push(pair.join("="));
      }
      if (searchArr.length) {
        newUrl += "?" + searchArr.join("&");
        if (ymmParams.length)
          ymmParams = "&" + ymmParams.slice(1);
      }
      newUrl += ymmParams;
      window.history.replaceState({ path: newUrl }, "", newUrl);
    }
    isSelectorValid() {
      return !this.ymmSelectors.every((i) => i.value.length);
    }
  });
  customElements.define("ymm-fitment", class extends HTMLElement {
    constructor() {
      super();
      const callback = async () => {
        const matchYMM = {};
        const ymmSelector = document.querySelector("ymm-selector");
        ymmSelector.querySelectorAll(".jsYMMSelect").forEach((item) => {
          if (item.value === "") return;
          matchYMM[item.name] = item.value;
        });

        const docResult = await getFitmentTableData(window.theme.product.id);
        const foundYMM = docResult?._source?.ymms?.find(ymm => {
          for (const [key, value] of Object.entries(matchYMM)) {
            if (String(ymm[key]) !== String(value)) return false;
          }
          return true;
        });

        this.setFitment = foundYMM;
        this.style.opacity = 1;
      };
      document.addEventListener("ymmData:Loaded", callback.bind(this));
      document.addEventListener("ymmData:Changed", callback.bind(this));
    }
    set setFitment(value) {
      let hasYMM = hasYMMData();
      if (!hasYMM) {
        this.setAttribute("data-state", "");
      } else {
        this.setAttribute("data-state", value ? "fitted" : "nofit");
      }
    }
  });
  customElements.define("fitment-table", class extends HTMLElement {
    constructor() {
      super();
      window.theme.product && this.fetchFitmentData();
    }
    async fetchFitmentData() {
      const result = await getFitmentTableData(window.theme.product.id);
      const tableItems = result?._source?.ymms;
      const tableBodyElement = this.querySelector("table tbody");
      if (!tableItems)
        return;
      tableItems.sort((a, b) => {
        return b.year - a.year;
      });
      tableItems.forEach((item) => {
        const tr = this.querySelector("table thead tr").cloneNode(true);
        tr.querySelector("td:first-child").innerHTML = `${item.year} ${item.make} ${item.model}`;
        tr.querySelector("td:last-child").innerHTML = item.note;
        tableBodyElement.insertAdjacentElement("beforeend", tr);
      });
    }
  });

  // app/scripts/function/ymmUtilsTeifi.js
  window.ymmOptions = {
    firstLoad: true
  };
  function floatEqual(a, b) {
    return Math.abs(parseInt(a) - parseInt(b)) < 1e-3;
  }
  function getYMMFilters() {
    const variantsSelectedOptions = {};
    const variantsPrice = {};
    const fitments = [];
    const productTypes = [];
    for (const el of document.querySelectorAll(".jsYMMParams")) {
      const { filterType, filterOptionName } = el.closest("[data-filter-type]").dataset;
      if (filterType === "variant_option") {
        if (el.type !== "checkbox" || !el.checked)
          continue;
        addSelectedOptions(filterOptionName, el.value);
      } else if (filterType === "variant_price") {
        const { name, value } = el;
        let n = void 0;
        if (value.trim() !== "") {
          const v = Number(value);
          const bound = Number(name === "gte" ? el.getAttribute("min") : el.getAttribute("max"));
          if (!floatEqual(v, bound)) {
            n = v;
          }
        }
        variantsPrice[el.name] = n;
      } else if (filterType === "fitment") {
        if (!el.checked)
          continue;
      } else if (filterType === "product_type") {
        if (!el.checked)
          continue;
        productTypes.push(el.value);
      } else {
        console.error("Unhandled filter element", el);
      }
    }
    if (Object.keys(YMM.getYMMValue()).length) {
      fitments.push("Vehicle Specific");
      fitments.push("Universal");
    }
    return { variantsSelectedOptions, variantsPrice, fitments, productTypes };
    function addSelectedOptions(key, value) {
      const selectedOptions = variantsSelectedOptions[key] ?? [];
      if (!selectedOptions.includes(value)) {
        selectedOptions.push(value);
      }
      variantsSelectedOptions[key] = selectedOptions;
    }
  }
  function getSizedMediaUrl(media, size) {
    let src = typeof media === "string" ? media : media["preview_image"] ? media["preview_image"]["src"] : media["url"];
    if (size === null) {
      return src;
    }
    if (size === "master") {
      return src.replace(/http(s)?:/, "");
    }
    const match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?$/i);
    if (match) {
      const prefix = src.split(match[0]);
      const suffix = match[0];
      return (prefix[0] + "_" + size + suffix).replace(/http(s)?:/, "");
    } else {
      return null;
    }
  }
  var YMM = {
    ymmAPI: async (body) => {
      const res = await fetch(SEARCH_API, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body)
      });
      if (!res.ok) {
        const text = await res.text();
        console.error("[ymmAPI] Error response:", res.status, text.slice(0, 200));
        throw new Error(`API error: ${res.status}`);
      }
      return res.json();
    },
    getYMMValue: () => {
      const ymm = {};
      for (const name of ["year", "make", "model", "generation"]) {
        const value = localStorage.getItem(`ymm-${name}`);
        if (value == null || value.trim() === "")
          continue;
        ymm[name] = value;
      }
      return ymm;
    },
    ymmSave: () => {
      (void 0).querySelectorAll("select").forEach((select) => {
        const name2 = select.getAttribute("name");
        const key2 = `ymm-${name2}`;
        const value2 = String(select.value);
        localStorage.setItem(key2, value2);
      });
    },
    ymmFilter: (container, aggOptions = null) => {
      const ymmValue = YMM.getYMMValue();
      container.lastQuery = JSON.stringify(ymmValue);
      const { size, page } = container;
      const filters = getYMMFilters();

      const sortElement = document.querySelector('[name="ymm_sort"]:checked');
      let sort = undefined;
      if (sortElement) {
        const type = sortElement.value;
        if (type === "manual") {
          sort = "manual";
        } else if (type.includes("price")) {
          sort = type.includes("descending") ? "price-desc" : "price-asc";
        } else if (type.includes("title")) {
          sort = type.includes("descending") ? "title-desc" : "title-asc";
        } else if (type.includes("created")) {
          sort = type.includes("descending") ? "created-desc" : "created-asc";
        }
      }

      return {
        year: ymmValue.year ? parseInt(ymmValue.year) : undefined,
        make: ymmValue.make || undefined,
        model: ymmValue.model || undefined,
        generation: ymmValue.generation || undefined,
        page: (page || 0) + 1,
        limit: size || 24,
        priceMin: filters.variantsPrice?.gte,
        priceMax: filters.variantsPrice?.lte,
        productTypes: filters.productTypes.length > 0 ? filters.productTypes : undefined,
        fitments: filters.fitments.length > 0 ? filters.fitments : undefined,
        includeUniversal: !!(container.dataset.collectionHandle),
        collectionHandle: container.dataset.collectionHandle || undefined,
        sort
      };
    },
    renderResult: function(hits, template) {
      try {
        const productTemplate = template;
        if (!hits || !hits.hits || !hits.hits.length) {
          return false;
        }
        let HTML = "";
        let results = hits.hits.map(({ _source }) => _source);
        const sortElement = document.querySelector('[name="ymm_sort"]:checked');
        if (sortElement && sortElement.value == "manual") {
          const orderArray = JSON.parse(document.getElementById("collectionSortDefault").textContent);
          results.sort((a, b) => {
            let indexOfA = orderArray.indexOf(a.handle);
            let indexOfB = orderArray.indexOf(b.handle);
            if (indexOfA === -1)
              indexOfA = orderArray.length;
            if (indexOfB === -1)
              indexOfB = orderArray.length;
            return indexOfA - indexOfB;
          });
        }

        // ============================================================================
        // Hide Price Functionality: Load hideprice metafield values from script tag
        // ============================================================================
        // The hideprice metafield (product.metafields.boost.hideprice) is pre-rendered
        // by Liquid in a script tag on the page. This allows us to access it synchronously
        // without blocking rendering or requiring API calls.
        let hidepriceMap = {};

        // Read hideprice data from pre-rendered script tag (synchronous, non-blocking)
        const scriptTag = document.getElementById('ymm-hideprice-data');
        if (scriptTag) {
          try {
            const data = JSON.parse(scriptTag.textContent);
            if (data && data.hideprice) {
              results.forEach(item => {
                if (data.hideprice[item.handle] !== undefined) {
                  hidepriceMap[item.handle] = String(data.hideprice[item.handle] || "0");
                }
              });
            }
          } catch (parseError) {
            // Silently fail if script tag is malformed - products will show prices by default
          }
        }

        // Check cached map for products not in the script tag (from previous renders)
        if (window._ymmHidepriceMap) {
          results.forEach(item => {
            if (!hidepriceMap[item.handle] && window._ymmHidepriceMap[item.handle]) {
              hidepriceMap[item.handle] = window._ymmHidepriceMap[item.handle];
            }
          });
        }

        // Fetch any missing products in background for future renders (non-blocking)
        const missingHandles = results.filter(item => !hidepriceMap[item.handle]).map(item => item.handle);
        if (missingHandles.length > 0 && !window._ymmHidepriceFetching && YMM.fetchHidepriceMetafields) {
          window._ymmHidepriceFetching = true;
          YMM.fetchHidepriceMetafields(missingHandles)
            .then(map => {
              window._ymmHidepriceMap = Object.assign(window._ymmHidepriceMap || {}, map);
              window._ymmHidepriceFetching = false;
            })
            .catch(() => {
              window._ymmHidepriceFetching = false;
            });
        }

        results.forEach((item) => {
        const parse = new DOMParser();
        let html = productTemplate;
        const { title, handle, images: [image], variants, metafields } = item;

        const { reviews_rating, reviews_rating_count, boost_tagline, boost_clp_promo } = metafields;
        let priceList = variants.map((i) => i.price);
        priceList.sort((a, b) => {
          return a - b;
        });
        const price = priceList[0] || 0;
        let review = 0;
        let reviewCount = 0;
        if (reviews_rating && reviews_rating.value != "NULL") {
          reviewCount = Math.round(+reviews_rating_count.value);
          review = JSON.parse(reviews_rating.value).value;
        }
        const array = [
          {
            key: "title",
            value: title
          },
          {
            key: "handle",
            value: handle
          },
          {
            key: "image",
            value: image?.url || "https://cdn.shopify.com/s/files/1/0601/4527/0921/t/10/assets/default-image.jpg?v=1692203040"
          },
          {
            key: "imageWidth",
            value: image?.width || 900
          },
          {
            key: "imageHeight",
            value: image?.height || 900
          },
          {
            key: "price",
            value: Intl.NumberFormat("en", { style: "currency", currency: "USD" }).format(price)
          },
          {
            key: "reviewCount",
            value: reviewCount
          },
          {
            key: "review",
            value: review
          },
          {
            key: "boost_tagline",
            value: boost_tagline?.value?.replace("NULL", "") || ""
          },
          {
            key: "isFirstVariantAvailable",
            value: variants[0].availableForSale
          },
          {
            key: "soldOut",
            value: variants.some(v => v.availableForSale)
              ? ''
              : `<div style="position:relative">
                  <div class="product-meta__label-list label-list"">
                    <span class="label label--subdued" style="margin-top:10px;">SOLD OUT</span>
                  </div>
                </div>`
          },
          {
            key: "isFirstVariantId",
            value: variants[0].id
          },
          {
            key: "hideprice",
            value: (() => {
              // Get hideprice value from the map (populated from script tag or cache)
              const fetchedValue = hidepriceMap[handle];
              return fetchedValue !== undefined ? String(fetchedValue) : "0";
            })()
          }
        ];
        array.forEach((item2) => {
          const regex = `{{${item2.key}}}`;
          html = html.replaceAll(regex, item2.value);
        });

        // Hide price if hideprice metafield equals "1"
        const hidepriceValue = hidepriceMap[handle] || "0";
        if (hidepriceValue === "1" || hidepriceValue === 1) {
          // Remove price container and adjust parent layout
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;
          const priceContainer = tempDiv.querySelector('.product-item-meta__price-list-container');
          if (priceContainer) {
            priceContainer.remove();
            // Adjust parent container to flex-start to prevent description from being pushed down
            const productItemMeta = tempDiv.querySelector('.product-item-meta');
            if (productItemMeta) {
              productItemMeta.style.justifyContent = 'flex-start';
            }
            html = tempDiv.innerHTML;
          }
        }

        const div = document.createElement("div");
        div.innerHTML = html;
        if (div.firstElementChild) {
          HTML += div.firstElementChild.outerHTML;
        }
        });

        return HTML || '';
      } catch (error) {
        return '';
      }
    },
    /**
     * Fetch hideprice metafield values for products
     * Reads from pre-rendered script tag on the page (populated by Liquid)
     *
     * @param {string[]} handles - Array of product handles to fetch hideprice for
     * @returns {Promise<Object>} Map of handle -> hideprice value (defaults to "0")
     */
    fetchHidepriceMetafields: async function(handles) {
      if (!handles || handles.length === 0) {
        return {};
      }

      const hidepriceMap = {};

      try {
        // Read from pre-rendered script tag (most efficient)
        const scriptTag = document.getElementById('ymm-hideprice-data');
        if (scriptTag) {
          try {
            const data = JSON.parse(scriptTag.textContent);
            if (data && data.hideprice) {
              handles.forEach(handle => {
                if (data.hideprice[handle] !== undefined) {
                  hidepriceMap[handle] = String(data.hideprice[handle] || "0");
                }
              });
            }
          } catch (parseError) {
            // Silently fail - products will default to showing price
          }
        }

        // Default missing products to "0" (show price)
        handles.forEach(handle => {
          if (!hidepriceMap[handle]) {
            hidepriceMap[handle] = "0";
          }
        });

        return hidepriceMap;
      } catch (error) {
        // Return empty map on error - products will show prices by default
        return {};
      }
    }
  };

  // app/scripts/component/ymmPaginate.js
  var customElementTagName = "ymm-paginate";
  !window.customElements.get(customElementTagName) && window.customElements.define(customElementTagName, class extends HTMLElement {
    constructor() {
      super();
      this.infiniteType = this.dataset.type == "infinite";
    }
    initInfiniteLoad() {
      this.observer = new IntersectionObserver((entries, observer) => {
        entries[0].isIntersecting && !this.classList.contains("hide") && window.dispatchEvent(new CustomEvent("ymm:filter", {
          detail: {
            type: "infinite",
            noScroll: true
          }
        }));
      });
      this.observer.observe(this);
    }
    build(totalPage, active) {
      this.classList.toggle("hide", totalPage < 1);
      this.querySelector(".paginate-list").innerHTML = "";
      if (this.infiniteType) {
        const index = active + 1;
        if (totalPage < 1 || index >= totalPage) {
          this.classList.toggle("hide", true);
          return;
        }
        const button = document.createElement("button");
        button.className = "btn active jsYMMPaginateItem";
        button.setAttribute("data-page", index);
        button.textContent = this.dataset.text;
        this.querySelector(".paginate-list").appendChild(button);
        return;
      }
      if (totalPage > 5) {
        const currentPageIndex = active + 1;
        [-2, -1, 0, 1, 2].forEach((number) => {
          const index = number + currentPageIndex;
          if (index <= 0 || index >= totalPage)
            return;
          number == -2 && index - 1 > 1 && (this.querySelector(".paginate-list").innerHTML += '<span class="inline-block">...</span>');
          const button = document.createElement("button");
          button.className = "btn disabled" + (index == currentPageIndex ? " active" : "");
          button.setAttribute("data-page", active + number);
          button.textContent = index;
          this.querySelector(".paginate-list").appendChild(button);
          number == 2 && totalPage - index > 1 && (this.querySelector(".paginate-list").innerHTML += '<span class="inline-block">...</span>');
        });
      } else {
        for (var i = 0; i < totalPage; i++) {
          const button = document.createElement("button");
          button.className = "btn disabled" + (i == active ? " active" : "");
          button.setAttribute("data-page", i);
          button.textContent = i + 1;
          this.querySelector(".paginate-list").appendChild(button);
        }
      }
      this.querySelectorAll(".paginate-list button")?.forEach((button) => this.setEvent(button));
    }
    setEvent(button) {
      button.classList.add("jsYMMPaginateItem");
      button.classList.remove("disabled");
    }
  });

  // app/scripts/component/ymmFilter.js
  var customElementTagName2 = "ymm-filter-component";
  !window.customElements.get(customElementTagName2) && window.customElements.define(customElementTagName2, class extends HTMLElement {
    constructor() {
      super();
      this.setDefault();
      !this.closest("modal-content, .shopify-section--popup, .shopify-section--modal") && this.filter(true);
      this.addEventListener("change", ({ target }) => {
        const filterType = target.closest("[data-filter-type]")?.dataset?.filterType;
        filterType && this.filter(false, filterType);
      });
      document.querySelector("#sort-by-popover")?.addEventListener("change", (e) => {
        e.stopImmediatePropagation();
        this.filter(false);
        document.querySelector("#sort-by-popover").open = false;
      });
      document.body.addEventListener("click", (e) => {
        const { target } = e;
        if (target.closest(".jsYMMPrev") || target.closest(".jsYMMNext")) {
          e.stopImmediatePropagation();
          const ymmValue = YMM.getYMMValue();
          const lastQuery = this.lastQuery || "";
          if (lastQuery == JSON.stringify(ymmValue)) {
            this.page = target.closest(".jsYMMNext") ? this.page + 1 : this.page - 1;
          }
          (target.closest(".jsYMMPrev") || target.closest(".jsYMMNext")).toggleAttribute("disabled", true);
          this.filter(false);
        }
        if (target.closest(".jsYMMPaginateItem")) {
          e.stopImmediatePropagation();
          target.closest(".jsYMMPaginateItem").toggleAttribute("disabled", true);
          this.page = +target.closest(".jsYMMPaginateItem").dataset.page;
          this.infiniteType && (this.loadMore = true);
          this.filter(false, null, this.loadMore);
        }
      });
    }
    callFilter(e) {
      if (this.isFiltering)
        return;
      if (!!(e.detail?.type == "infinite")) {
        this.page++;
        this.loadMore = true;
      } else {
        this.page = 0;
      }
      this.filter(false, null, e.detail?.noScroll);
    }
    connectedCallback() {
      !window.ymmFilterEvent && window.addEventListener("ymm:filter", (e) => {
        this.callFilter(e);
      });
      window.ymmFilterEvent = true;
    }
    disconnectedCallback() {
      window.ymmFilterEvent = null;
      window.removeEventListener("ymm:filter", (e) => {
        this.callFilter(e);
      });
    }
    setDefault() {
      this.page = 0;
      this.size = +this.dataset.size || 24;
      this.infiniteType = this.dataset.type == "infinite";
    }
    async filter(reset = false, filterType = null, noScroll = false) {
      if (this.hasAttribute("data-ymm-disabled")) {
        return;
      }

      document.documentElement.dispatchEvent(new Event("theme:loading:start"));
      this.isFiltering = true;

      // Show skeleton loading state
      const resultsContainer = document.querySelector(".jsYMMResult");
      const skeletonTemplate = document.getElementById("jsYMMSkeleton");
      if (resultsContainer && skeletonTemplate && !this.loadMore) {
        resultsContainer.classList.remove("no-results");
        resultsContainer.innerHTML = skeletonTemplate.content.cloneNode(true).firstElementChild.outerHTML;
      }

      const { ymmAPI: ymmAPI2, ymmFilter: ymmFilter2, renderResult } = YMM;

      let hits, aggregations;
      try {
        const response = await ymmAPI2(ymmFilter2(this, { include: true }));
        hits = response.hits;
        aggregations = response.aggregations;
      } catch (error) {
        console.error("[ymm-filter] API error:", error);
        const results = document.querySelector(".jsYMMResult");
        const fallbackTemplate = document.getElementById("jsYMMLiquidFallback");
        if (results) {
          if (fallbackTemplate) {
            results.innerHTML = fallbackTemplate.innerHTML;
          } else {
            results.innerHTML = '<p class="text-center">Error loading products. Please try again.</p>';
          }
        }
        const pagination = document.querySelector(".jsYMMPaginate");
        const viewAll = document.querySelector(".ymm-view-all");
        if (pagination) pagination.style.display = "none";
        if (viewAll) viewAll.style.display = "none";
        document.documentElement.dispatchEvent(new Event("theme:loading:end"));
        this.isFiltering = null;
        this.loadMore = null;
        return;
      }

      this.populateFilters(aggregations, reset, filterType);
      const sortElment = document.querySelector('input[name="ymm_sort"]:checked');
      const sortValueDisplay = document.getElementById("sort-by-selected-value");
      if (sortValueDisplay && sortElment?.nextElementSibling) {
        sortValueDisplay.innerHTML = sortElment.nextElementSibling.innerHTML;
      }
      const from = this.page * this.size;
      const totalPage = Math.ceil(hits.total.value / this.size);
      document.querySelector("ymm-paginate").build(totalPage, this.page);
      document.querySelector(".jsYMMPaginate .jsYMMPrev")?.classList.toggle("disabled", !from);
      document.querySelector(".jsYMMPaginate .jsYMMNext")?.classList.toggle("disabled", from + hits.hits.length >= hits.total.value);
      const resultsCount = document.querySelector(".jsYMMResultCount");
      if (resultsCount) {
        const currentItemShowing = isEmpty(hits.hits) ? 0 : hits.hits.length;

        let totalItems = currentItemShowing > 0 ? hits.total.value : 0;
        if (this.infiniteType)
          resultsCount.innerText = `Showing ${from + currentItemShowing} of ${totalItems} results`;
        else
          resultsCount.innerText = `${totalItems} results (showing ${from + 1}-${from + currentItemShowing})`;
        resultsCount.classList.toggle("hide", totalItems == 0);
      }
      const results = document.querySelector(".jsYMMResult");
      const resultItemTemplate = document.getElementById("jsYMMItem").content.firstElementChild.cloneNode(true).outerHTML;

      if (this.infiniteType) {
        if (this.loadMore) {
          results.innerHTML += renderResult.call(this, hits, resultItemTemplate);
        } else {
          results.innerHTML = (isEmpty(hits.hits) ?
            results.dataset.text :
            renderResult.call(this, hits, resultItemTemplate));
          this.page = 0;
        }
      } else {
        results.innerHTML = (isEmpty(hits.hits) ?
          results.dataset.text :
          renderResult.call(this, hits, resultItemTemplate));
      }
      results.classList.toggle("no-results", !results.childElementCount);
      results.querySelectorAll("product-item").forEach(async (product) => {
        await product.untilVisible({ threshold: product.clientHeight > 0 ? Math.min(50 / product.clientHeight, 1) : 0 });
      });
      if (document.querySelector(".jsYMMContainer"))
        document.querySelector(".jsYMMContainer").style.display = "block";
      this.querySelector("ymm-selector").updateURL();
      this.closest("popup-ymm-search")?.close();
      if (!reset && !noScroll) {
        const scrollTarget = document.querySelector(".product-facet__meta-bar") || document.querySelector(".jsYMMResult");
        scrollTarget?.scrollIntoView({ behavior: "smooth", block: "start" });
      }
      document.documentElement.dispatchEvent(new Event("theme:loading:end"));
      document.documentElement.dispatchEvent(new Event("ymm:filter:loaded"));
      this.isFiltering = null;
      this.loadMore = null;
    }
    populateFilters(aggs, reset = false, filterType = null) {
      if (reset || filterType === "fitment") {
        const priceRangeElement = document.querySelector('[data-filter-type="variant_price"]');
        if (!priceRangeElement || !aggs?.variants) return;
        const gte = priceRangeElement.querySelector('input[name*="gte"]');
        const lte = priceRangeElement.querySelector('input[name*="lte"]');
        const { min_price, max_price } = aggs.variants;
        const min = min_price.value;
        const max = max_price.value;
        const oldMin = gte.getAttribute("min");
        const oldMax = lte.getAttribute("max");
        priceRangeElement.querySelectorAll("input").forEach((input) => {
          if (min != null)
            input.setAttribute("min", min);
          if (max != null)
            input.setAttribute("max", max);
          if (input.classList.contains("jsRangeMin")) {
            if (min != null)
              input.placeholder = min;
            if (min != null && (reset || floatEqual(gte.value, oldMin))) {
              input.value = min;
            }
          }
          if (input.classList.contains("jsRangeMax")) {
            if (max != null)
              input.placeholder = max;
            if (max != null && (reset || floatEqual(lte.value, oldMax))) {
              input.value = max;
            }
          }
        });
      }
      populateFilter(document.querySelector('[data-filter-type="fitment"]'), ["Universal", "Vehicle Specific"].map((key) => ({ key })), null, window.ymmOptions.firstLoad && Object.keys(YMM.getYMMValue()).length);
      populateFilter(document.querySelector('[data-filter-type="product_type"]'), aggs.product_types.buckets);
      window.ymmOptions.firstLoad = false;
      for (const el of document.querySelectorAll('[data-filter-type="variant_option"]')) {
        populateFilter(el, aggs?.[el.dataset.filterOptionName]?.all_values?.all_possible_values?.buckets);
      }
      function populateFilter(el, buckets, checked = false, forceChecked = false) {
        if (el == null || buckets == null)
          return;
        const wrapper = el.querySelector(".jsYMMFilterWrapper");
        const checkedValues = /* @__PURE__ */ new Set();
        const inputs = wrapper.querySelectorAll("input");
        for (const input of inputs) {
          input.checked && checkedValues.add(input.value);
        }
        wrapper.innerHTML = "";
        const filteredBuckets = buckets.filter(b => b.doc_count == null || b.doc_count > 0);
        el.closest(".js-filter-group").toggleAttribute("hidden", !filteredBuckets.length || false);
        for (let i = 0; i < filteredBuckets.length; i++) {
          const { key, hide, doc_count } = filteredBuckets[i];
          if (key == null || String(key).trim() === "")
            continue;
          const id = `${el.dataset.filterType}-${key}-${i}`;
          const item = el.querySelector("template").content.firstElementChild.cloneNode(true);
          item.toggleAttribute("hidden", hide || false);
          const input = item.querySelector("input");
          input.value = key;
          input.id = id;
          if (checkedValues.has(key) || (inputs.length === 0 || reset) && checked || forceChecked)
            input.checked = true;
          const label = item.querySelector("label");
          label.setAttribute("for", id);
          const span = item.querySelector(".filter-label");
          span.textContent = key;
          const countSpan = item.querySelector(".filter-count");
          if (countSpan && typeof doc_count === 'number' && doc_count > 0) {
            countSpan.textContent = `(${doc_count})`;
          }
          wrapper.appendChild(item);
        }
      }
    }
  });
  !window.customElements.get("ymm-filter-section") && window.customElements.define("ymm-filter-section", class extends HTMLElement {
    constructor() {
      super();
      this.setDefault();
      this.addEventListener("change", ({ target }) => {
        const filterType = target.closest("[data-filter-type]")?.dataset?.filterType;
        filterType && this.filter(false, filterType);
      });
    }
    callFilter(e) {
      if (this.isFiltering)
        return;
      if (!!(e.detail?.type == "infinite")) {
        this.page++;
        this.loadMore = true;
      }
      this.filter(false, null, e.detail?.noScroll);
    }
    connectedCallback() {
      window.addEventListener("ymm:filter", (e) => {
        this.callFilter(e);
      });
      document.addEventListener("ymmData:Loaded", () => {
        if (hasYMMData()) {
          this.filter(false, null, true);
        }
      });
    }
    disconnectedCallback() {
      window.removeEventListener("ymm:filter", (e) => {
        this.callFilter(e);
      });
    }
    setDefault() {
      this.page = 0;
      this.size = +this.dataset.size || 24;
      this.infiniteType = this.dataset.type == "infinite";
    }
    async filter(reset = false, filterType = null, noScroll = false) {
      document.documentElement.dispatchEvent(new Event("theme:loading:start"));
      this.isFiltering = true;

      const results = this.querySelector(".jsYMMResult");
      if (!results) {
        this.isFiltering = null;
        return;
      }

      if (this.hasAttribute("data-ymm-disabled")) {
        const fallbackTemplate = document.getElementById("jsYMMLiquidFallback");
        if (fallbackTemplate) {
          results.innerHTML = fallbackTemplate.innerHTML;
        }
        this.closest(".jsYMMContainer")?.style.setProperty("display", "block");
        document.documentElement.dispatchEvent(new Event("theme:loading:end"));
        this.isFiltering = null;
        return;
      }

      const skeletonTemplate = document.getElementById("jsYMMSkeleton");
      if (skeletonTemplate && !this.loadMore) {
        results.innerHTML = skeletonTemplate.content.cloneNode(true).firstElementChild.outerHTML;
      }

      const { ymmAPI: ymmAPI2, ymmFilter: ymmFilter2, renderResult } = YMM;

      let hits;
      try {
        const response = await ymmAPI2(ymmFilter2(this, { include: true }));
        hits = response.hits;
      } catch (error) {
        console.error("[ymm-filter-section] API error:", error);
        const fallbackTemplate = document.getElementById("jsYMMLiquidFallback");
        if (fallbackTemplate) {
          results.innerHTML = fallbackTemplate.innerHTML;
        } else {
          results.innerHTML = '<p class="text-center">Error loading products. Please try again.</p>';
        }
        this.closest(".jsYMMContainer")?.style.setProperty("display", "block");
        document.documentElement.dispatchEvent(new Event("theme:loading:end"));
        this.isFiltering = null;
        this.loadMore = null;
        return;
      }

      const resultItemTemplate = document.getElementById("jsYMMItem").content.firstElementChild.cloneNode(true).outerHTML;
      if (this.infiniteType) {
        if (this.loadMore) {
          results.innerHTML += renderResult.call(this, hits, resultItemTemplate);
        } else {
          results.innerHTML = renderResult.call(this, hits, resultItemTemplate) || results.dataset.text;
          this.page = 0;
        }
      } else {
        results.innerHTML = renderResult.call(this, hits, resultItemTemplate) || results.dataset.text;
      }
      results.classList.toggle("no-results", !results.childElementCount);
      results.querySelectorAll("product-item").forEach(async (product) => {
        await product.untilVisible({ threshold: product.clientHeight > 0 ? Math.min(50 / product.clientHeight, 1) : 0 });
      });
      // Show the container for this section
      this.closest(".jsYMMContainer")?.style.setProperty("display", "block");
      this.querySelector("ymm-selector")?.updateURL();
      if (!reset && !noScroll) {
        const scrollTarget = this.querySelector(".product-facet__meta-bar") || results;
        scrollTarget?.scrollIntoView({ behavior: "smooth", block: "start" });
      }
      document.documentElement.dispatchEvent(new Event("theme:loading:end"));
      document.documentElement.dispatchEvent(new Event("ymm:filter:loaded"));
      if (this.hasAttribute("data-hide-after-load")) {
        this.closest(".shopify-section").toggleAttribute("hidden", true);
      }
      this.isFiltering = null;
      this.loadMore = null;
    }
  });

  // app/scripts/component/productSwatches.js
  var productSwatches = class extends HTMLElement {
    constructor() {
      super();
      this.productItem = this.closest("product-item");
      this.insertTarget = this.productItem.querySelector(".jsSwatchImageHolder");
      this.swatchEls = document.createElement("div");
      this.swatchEls.innerHTML = this.insertTarget.textContent;
      this.querySelectorAll(".swatch-input").forEach((item) => {
        item.addEventListener("change", () => {
          const value = item.value;
          const swatchImg = Array.from(this.swatchEls.querySelectorAll(".image-swatch")).find((item2) => {
            return item2.dataset.value == value;
          });
          this.productItem.querySelectorAll(".image-swatch").forEach((item2) => item2.remove());
          if (!swatchImg)
            return;
          const newElm = swatchImg.cloneNode(true);
          newElm.classList.add("active");
          this.insertTarget.insertAdjacentElement("afterend", newElm);
        });
      });
    }
  };
  customElements.define("product-swatch", productSwatches);

  // app/scripts/component/reviewCounter.js
  customElements.define("review-counter", class extends HTMLElement {
    connectedCallback() {
      this.style.display = "none";
      const observerOptions = {
        childList: true,
        attributes: true,
        subtree: true
      };
      this.observer = new MutationObserver(this.callback.bind(this));
      this.observer.observe(this, observerOptions);
    }
    callback(mutationList, observer) {
      mutationList.forEach((mutation) => {
        switch (mutation.type) {
          case "childList":
            const target = this.querySelector("[data-count]");
            if (target) {
              this.render(target);
              this.observer.disconnect();
            }
            break;
          case "attributes":
            break;
        }
      });
    }
    render(target) {
      document.querySelectorAll(this.tagName).forEach((item) => {
        item.innerHTML = target.dataset.count + " " + item.dataset.msg;
        item.style.display = null;
      });
    }
  });

  // app/scripts/theme-custom.js
  document.addEventListener("DOMContentLoaded", () => {
    // Hide "Shipping Protection" line items in cart
    document.querySelectorAll("line-item").forEach(item => {
      if (item.innerText.includes("Shipping Protection")) {
        item.style.display = "none";
      }
    });
    document.addEventListener("click", (e) => {
      const target = e.target;
      if (target.closest("a") && target.closest("a").href.includes("#ymm")) {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth"
        });
        document.querySelector("#shopify-section-header ymm-selector").open = true;
      }
    });

    // Track header YMM selector height for mobile toolbar offset
    const headerYmmSelector = document.querySelector(".header__wrapper .ymm-selector");
    if (headerYmmSelector) {
      const updateYmmHeight = () => {
        document.documentElement.style.setProperty("--ymm-selector-height", headerYmmSelector.offsetHeight + "px");
      };
      updateYmmHeight();
      new ResizeObserver(updateYmmHeight).observe(headerYmmSelector);
    }
  });
})();
